import type {
  PriceFreezeOffer,
  TripDetailsV2,
} from "@b2bportal/air-shopping-api";
import {
  type Offer,
  PriceFreezeFlightPaymentFinalizeResult,
  type PriceFreezeOfferDataResponse,
  PriceQuoteData,
} from "@b2bportal/price-freeze-api";
import type { CipherText } from "@b2bportal/purchase-api";
import type { IContactInfo, CartContext } from "@hopper-b2b/checkout";
import type { PassengerTypes, SessionInfo } from "@hopper-b2b/types";
import type { StateValue } from "xstate";

export type StateWithoutValue = { context: PriceFreezeMachineContext };
export type State = { value: StateValue; context: PriceFreezeMachineContext };

export enum PriceFreezePurchaseState {
  loading = "loading",
  priceFreezeOffer = "priceFreezeOffer",
  scheduleQuote = "scheduleQuote",
  payment = "payment",
  scheduleFulfill = "scheduleFullfill",
  fulfillFailed = "fulfillFailed",
  confirmation = "confirmation",
}

export enum ScheduleQuoteState {
  schedule = "schedule",
  polling = "polling",
  error = "error",
}

export enum ScheduleFulfillState {
  schedule = "schedule",
  polling = "polling",
  error = "error",
}

export enum ScheduleFulfillErrorModal {
  Invalid = "Invalid",
  Missing = "Missing",
  NoCipherText = "NoCipherText",
  FailedPolling = "FailedPolling",
  FailedPollingNoErrorCode = "FailedPollingNoErrorCode",
}

export type PassengerMap = {
  [key in PassengerTypes]?: number;
};

export interface PriceFreezeMachineContext extends CartContext {
  sessionInfo: SessionInfo;
  flightShop: {
    tripDetails?: TripDetailsV2;
    tripId?: string;
    fareId?: string;
  };
  contactInformation?: IContactInfo;
  passengerMap: PassengerMap;
  defaultPriceFreezeOffer?: PriceFreezeOffer;
  [PriceFreezePurchaseState.priceFreezeOffer]: {
    visited: boolean;
    priceFreezeOfferData?: PriceFreezeOfferDataResponse;
    priceFreezeOfferDataIndex: number;
    priceFreezeOffer?: Offer;
  };
  [PriceFreezePurchaseState.payment]: {
    paymentSessionToken?: string;
    paymentQuoteToken?: CipherText;
    error?: any;
    visited: boolean;
  };
  [PriceFreezePurchaseState.confirmation]: {
    visited: boolean;
  };
}

export enum CheckoutQueryParams {
  tripId = "tripId",
  fareId = "fareId",
  checkoutState = "checkoutState",
}

export enum ScheduleQuoteErrorModal {
  Invalid = "Invalid",
  Missing = "Missing",
  NoSelectedTrip = "NoSelectedTrip",
  NoCipherText = "NoCipherText",
  FailedPolling = "FailedPolling",
  FailedPollingNoErrorCode = "FailedPollingNoErrorCode",
}

export type ScheduleQuoteError = {
  type: ScheduleQuoteErrorModal;
  data?: unknown;
};
